import {SearchCriteria} from '../../gallery/types/SearchCriteria';

export interface GalleryDisplayPreferences {
  zoomedIn: boolean;
  withDescriptions: boolean;
  columnsCount: number;
  showMap?: boolean;
}

export interface GalleryPaginationPreferences {
  itemsPerPage: number;
}

export interface GalleryPreferences {
  display: GalleryDisplayPreferences;
  pagination: GalleryPaginationPreferences;
  filters: SearchCriteria;
}

export interface LocationsFilters {
  organizationalUnitIds: string[];
  hierarchyType: string;
}

export interface LocationsPreferences {
  filters: LocationsFilters;
}

export interface UserPreferences {
  gallery: GalleryPreferences;
  locations: LocationsPreferences;
}

export const DEFAULT_PREFERENCES: UserPreferences = {
  gallery: {
    display: {
      zoomedIn: true,
      withDescriptions: true,
      columnsCount: 4,
      showMap: false
    },
    pagination: {
      itemsPerPage: 8
    },
    filters: {}
  },
  locations: {
    filters: {
      organizationalUnitIds: [],
      hierarchyType: 'church'
    }
  }
};

